<template>
    <table class="address-list dt-table">
        <thead>
            <tr>
                <th>{{ l('CUSTOMER_DETAILS.ADDRESS') }}</th>
                <th class="dt-table__cell--last">
                    <slot></slot>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="address in addresses"
                :key="address.ID">
                <td>
                    {{ address.getFormattedAddress() }}
                </td>
                <td class="dt-table__cell--last dt-table__btn-cell desktop-only">
                    <span v-if="address.defaultBilling"
                          class="indicator indicator-success mr-1">
                        {{ l('CUSTOMER_DETAILS.PRIMARY_ADDRESS') }}
                    </span>
                    <SquareBtn v-else
                               size="lg"
                               color="primary"
                               :loading="changingPrimary"
                               @click="$emit('set-primary', address)">
                        {{ l('CUSTOMER_DETAILS.SET_AS_PRIMARY') }}
                    </SquareBtn>

                    <SquareBtn size="lg"
                               color="info"
                               class="address-list__edit-btn"
                               @click="$emit('edit', address)">
                        <i class="fa-solid fa-pencil"></i>
                    </SquareBtn>

                    <SquareBtn size="lg"
                               color="danger"
                               class="address-list__delete-btn"
                               @click="$emit('delete', address)">
                        <i class="fa-solid fa-trash-can"></i>
                    </squarebtn>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';

export default {
    components: { SquareBtn },

    props: {
        /**
         * @type {Address[]}
         */
        addresses: {
            type: Array,
            required: true,
        },

        changingPrimary: {
            type: Boolean,
            default: false,
        },
    },

    emits: [
        'edit',
        'set-primary',
        'delete',
    ],
};
</script>
